module.exports = __webpack_public_path__ + "img/profilo3.aedc7248.png";